import { useCallback, useEffect, useState } from 'react';
import AdminPageHeader from '../components/AdminPageHeader';
import AdminTable from '../components/AdminTable';
import FilterButtons from '../components/FilterButtons';
import LoadStatus from '../components/LoadStatus';
import useSearchFilter from '../components/useSearchFilter';
import { getReviews } from './reviewApi';
import { toStars } from './stars';

const FILTERS = [{ key: 'all', label: '전체' }, ...[5, 4, 3, 2, 1].map(score => ({ key: String(score), label: `${score}점` }))];

const COLUMNS = [
    { key: 'created_at', label: '작성일', className: 'nowrap muted' },
    { key: 'user', label: '사용자', className: 'nowrap', render: row => <>{row.user_name || '—'}<br /><span className="muted">{row.user_email}</span></> },
    { key: 'rating', label: '별점', className: 'nowrap', render: row => <span aria-label={`${row.rating}점`} style={{ color: '#c0842a' }}>{toStars(row.rating)}</span> },
    // 목록 응답의 feedback은 첫 줄·최대 200자 요약이다. 전문은 상세에서 본다.
    { key: 'feedback', label: '피드백', className: 'wide', render: row => row.feedback || <span className="muted">내용 없음</span> },
];

// 상세 화면 경로를 만든다.
function toDetailPath(row) {
    return `/admin/feedback/${encodeURIComponent(row.id)}`;
}

// 사용자들이 남긴 별점·피드백 목록 화면. 별점 필터는 주소(?rating)에 남겨 상세에서 돌아와도 유지한다.
export default function FeedbackListPage() {
    const [rating, setRating] = useSearchFilter('rating', FILTERS);
    const [reviews, setReviews] = useState(null);
    const [error, setError] = useState('');

    // 현재 별점 필터의 피드백 목록을 불러온다.
    const load = useCallback(async () => {
        setError('');
        setReviews(null);
        try {
            setReviews(await getReviews(rating));
        } catch (loadError) {
            setError(loadError.message);
        }
    }, [rating]);

    useEffect(() => { load(); }, [load]);

    return (
        <>
            <AdminPageHeader title="피드백" count={reviews?.length} />
            <FilterButtons label="별점 필터" options={FILTERS} value={rating} onChange={setRating} />
            {reviews ? <AdminTable columns={COLUMNS} rows={reviews} rowKey="id" getRowLink={toDetailPath} /> : <LoadStatus error={error} onRetry={load} />}
        </>
    );
}
